export default "__VITE_ASSET__CeimVYg6__"